import { getAllOffers } from "../../../../../../../../config/Services";
import { CircularProgress, Modal } from "@mui/material";
import OffersCard from "../../../offers/components/offersCard/offersCard";
import { useEffect, useState } from "react";
import "./index.css";

// Helper: strip time-of-day so only the calendar date is compared
const toDateOnly = (dateInput) => {
  const d = new Date(dateInput);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
};

export const OfferListing = ({ offerModal, handleOfferModalClose }) => {
  const [offerListData, setOfferListData] = useState({});
  const [loader, setLoader] = useState(true);
  const orgId = localStorage.getItem("orgId");
  const locId = localStorage.getItem("locId");

  useEffect(() => {
    if (!offerModal) return;
    setLoader(true);
    const payload = {
      pageNumber: 1,
      pageSize: 100,
      locationId: locId,
      orgId: orgId,
      offerType: null,
      searchBox: null,
    };

    getAllOffers(payload).then((response) => {
      setLoader(false);
      const offers = response?.data?.data?.data;
      console.log("offers", offers);
      if (!offers) return;

      const grouped = {
        buyXGetY: [],
        offerOnMrp: [],
        buyXGetDiscount: [],
        buyXGetDiscountOnY: [],
        comboOfferDiscount: [],
        stepPromotions: [],
      };

      const now = new Date();

      offers.forEach((e) => {
        console.log(e, "this is the e", now);
        if (e?.offerModels?.length === 0) return;

        const validModels = e?.offerModels?.filter((ele) => {
          // Support validUpto/validFrom on either the model (ele) or the parent offer (e)
          const validUptoStr = ele?.validUpto || e?.validUpto;

          // No validUpto date at all -> exclude this offer
          if (!validUptoStr || validUptoStr === "") return false;

          const validFromStr = ele?.validFrom || e?.validFrom;
          const fromDate = validFromStr ? toDateOnly(validFromStr) : null;
          const uptoDate = toDateOnly(validUptoStr);
          const currentDate = toDateOnly(now);

          // If today is before 'from' date, it's not valid yet
          if (fromDate && currentDate < fromDate) return false;
          // If today is after the 'upto' date, it's expired
          if (currentDate > uptoDate) return false;

          // Otherwise (today <= uptoDate), it's still valid — even on the upto date itself
          return true;
        });

        const offerList = validModels.map((ele) => ({
          offerType: e.offerType,
          mainProductName: ele.mainGtinDetails?.itemName,
          mainProductMrp: ele.mainGtinDetails?.mrp,
          mainProductSp: ele.mainGtinDetails?.sellingPrice,
          mainProductGtin: ele.mainGtinDetails?.gtin,
          offerProductDetails: ele.offerDetailsModelList || [],
          validFrom: ele?.validFrom || "",
          validUpto: ele?.validUpto || "",
        }));

        switch (e.offerType) {
          case "BUY X GET Y":
          case "BUY_X_GET_Y":
            grouped.buyXGetY.push(...offerList);
            break;
          case "OFFER ON MRP":
          case "OFFER_ON_MRP":
            grouped.offerOnMrp.push(...offerList);
            break;
          case "BUY X GET DISCOUNT":
          case "BUY_X_GET_DISCOUNT":
            grouped.buyXGetDiscount.push(...offerList);
            break;
          case "BUY X GET DISCOUNT ON Y":
          case "BUY_X_GET_DISCOUNT_ON_Y":
            grouped.buyXGetDiscountOnY.push(...offerList);
            break;
          case "COMBO OFFER DISCOUNT":
          case "COMBO_OFFER_DISCOUNT":
            grouped.comboOfferDiscount.push(...offerList);
            break;
          case "STEP PROMOTIONS":
          case "STEP_PROMOTIONS":
            grouped.stepPromotions.push(...offerList);
            break;
          default:
            break;
        }
      });

      setOfferListData(grouped);
    });
  }, [offerModal]);

  const isEmpty = Object.values(offerListData).every((arr) => arr.length === 0);

  return (
    <Modal
      open={offerModal}
      onClose={handleOfferModalClose}
      slotProps={{ backdrop: { style: { backgroundColor: "rgba(0,0,0,0.35)" } } }}
    >
      <div className="ofd-shell">
        {/* Header */}
        <div className="ofd-header">
          <div className="ofd-header-left">
            <h1 className="ofd-title" data-testid="text-action-drawer-title">
              Offers
            </h1>
          </div>
          <div className="ofd-header-right">
            <button
              className="ofd-close"
              onClick={handleOfferModalClose}
              data-testid="button-action-drawer-close"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-x ofd-close-icon"
                aria-hidden="true"
              >
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
              </svg>
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="ofd-body">
          {loader ? (
            <div className="ofd-loader">
              <CircularProgress size={36} sx={{ color: "#2563eb" }} />
            </div>
          ) : isEmpty ? (
            <div className="ofd-empty">
              <p>No offers available</p>
            </div>
          ) : (
            <div className="ofd-cards-wrapper">
              {Object.entries(offerListData).map(([offerType, offers]) =>
                offers?.length > 0 ? (
                  <div key={offerType} className="ofd-type-section">
                    {offers?.map((offer, index) => (
                      <OffersCard offer={offer} key={index} offerType={offerType} />
                    ))}
                  </div>
                ) : null
              )}
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};
